import { Button, IconButton, TextField, Drawer } from "@mui/material";
import { CloseOutlined } from "@mui/icons-material";
import { useState } from "react";
import "./index.scss";
import { invokeApi } from "../../utils/http-service";
import { toast } from "react-toastify";
import { REST_URLS } from "../../../common-utilities/utils/end-points/subway-subs";
import { HOSTNAME } from "../../../common-utilities/utils/end-points";
import { HTTP_METHODS } from "../../../common-utilities/utils/http-service";

export const AddCorporation = ({
  onClose,
  corporationFlag,
  setPersonData,
  setCorporationList,
}) => {
  const [corporationDetails, setCorporationDetails] = useState({});
  const setCorporationDetailsOnChanges = (e) => {
    const { name, value } = e.target;
    setCorporationDetails((prevDetails) => ({ ...prevDetails, [name]: value }));
  };

  const createCorporation = () => {
    if (!corporationDetails.name || !corporationDetails.name.trim()) {
      toast.error("Name is required", { autoClose: 2000 });
      return;
    }

    invokeApi(
      HTTP_METHODS.POST,
      `${HOSTNAME}${REST_URLS.CREATE_CORPORATION}`,
      corporationDetails
    )
      .then((res) => {
        if (res?.message) {
          toast.error(res?.message, { autoClose: 2000 });
          return;
        }

        if (setCorporationList) {
          setCorporationList((prevList) => [
            ...prevList,
            { label: res.name, value: res.id },
          ]);
        }
        if (setPersonData) {
          setPersonData((prevVal) => ({
            ...prevVal,
            personDetails: {
              ...prevVal.personDetails,
              corporation: res.id,
            },
          }));
        }
        toast.success("Corporation created successfully", { autoClose: 2000 });
      })
      .catch((err) => {
        toast.error(err.message, { autoClose: 2000 });
      });
  };
  return (
    <>
      <Drawer anchor="right" open={corporationFlag} onClose={() => onClose()}>
        <div className="person-add-corporation">
          <div>
            <div className="drawer-header">
              <span className="title">Create Corporation</span>
              <IconButton
                onClick={() => {
                  onClose();
                }}
              >
                <CloseOutlined />
              </IconButton>
            </div>

            <div className="f-r-2">
              <div>
                <TextField
                  label="Name"
                  value={corporationDetails.name || ""}
                  name="name"
                  onChange={setCorporationDetailsOnChanges}
                />
              </div>
              <div>
                <Button
                  size="small"
                  onClick={createCorporation}
                  variant="contained"
                  fullWidth
                  sx={{ mt: 3 }}
                >
                  Save
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Drawer>
    </>
  );
};
